<template>
  <div>
  <Modal :mask-closable="false" title="新增课程音频" v-model="visible" width="600px" @on-ok="saveData">
    <Form ref="audioForm" class="form"
          :model="formData" :rules="audioRule"
          :label-width="80">
      <Row>
        <Col :span="22">
        <Form-item label="教材版本" prop="version" :label-width="100">
          <Select :transfer="true" v-model.number="formData.version" clearable @on-change="onVersionChange">
            <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
        <Form-item label="选择开始Level" prop="levelId" :label-width="100">
          <Select :transfer="true" v-model.number="formData.levelId" clearable filterable @on-change="onLevelChange">
            <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
        <Form-item label="选择对应课程" prop="lessonId" :label-width="100">
          <Select :transfer="true" v-model.number="formData.lessonId" clearable filterable>
            <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="音频标题" prop="title" :label-width="100">
            <Input v-model="formData.title" type="text"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="上传音频" :label-width="100" prop="audioUrl">
            <el-upload
              class="upload-demo"
              :action="$appConfig.baseUrl + '/upload/fileUpload'"
              :on-change="handleChange"
              :on-success="handleSuccess"
              :headers="headers"
              :on-progress="handleProgress"
              :before-upload="beforeUpload"
              accept="audio/mpeg"
              :limit="2"
              multiple
              :file-list="fileList">
              <el-button size="small"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
            </el-upload>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
  export default {
    components: {},
    name: 'LessonAudioInsertModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        id: null,
        levels: [],
        lessons: [],
        headers: {},
        fileList: [],
        loadingInsert: false,
        formData: {
          lessonId: null,
          levelId: '',
          audioUrl: '',
          version: null,
          title: ''
        },
        visible: this.value,
        audioRule: {
          version: [
            { type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }
          ],
          lessonId: [
            { type: 'integer', required: true, message: '请选择对应课程', trigger: 'blur' },
          ],
          levelId: [
            { type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }
          ],
          audioUrl: [
            { type: 'string', required: true, message: '请上传音频', trigger: 'blur' }
          ],
          title: [
            { type: 'string', required: true, message: '请输入音频标题', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      handleChange (file, fileList) {
        this.fileList = fileList.slice(-1)
      },
      handleSuccess (res, file, fileList) {
        this.formData.audioUrl = res.data.name
        this.audioUrl = res.data.url
      },
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      handleProgress (event, file, fileList) {
        if (event.percent === 100) {
          event.percent = 99
        }
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
      },
      saveData () {
        let self = this
        self.loadingInsert = true
        self.$refs.audioForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsert = false
            return
          }
          self.$http.post('/bookLessonAudio/insert', self.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('新增成功!')
              self.loadingInsert = false
              self.visible = false
              self.successCallback()
            }
          }).catch(function (e) {
            self.loadingInsert = false
            self.$Message.error(e.msg)
          })
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.levels = []
          this.lessons = []
          this.fileList = []
          this.formData = {}
          this.$emit('on-close', val)
        }
      }
    },
    mounted () {
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// LessonAudioInsertModal.vue?8ee9ec38